package com.nonopn.skywatcher.design.loader

import eu.codlab.viewmodel.StateViewModel
import korlibs.io.async.launch
import kotlinx.serialization.Serializable

@Suppress("TooManyFunctions")
class LocalLoaderModel : StateViewModel<LocalLoaderModelState>(
    LocalLoaderModelState()
) {
    fun show() = setVisibility(true)

    fun hide() = setVisibility(false)

    private fun setVisibility(visibility: Boolean) {
        viewModelScope.launch {
            try {
                updateState { copy(isVisible = visibility) }
            } catch (_: Throwable) {
                // nothing
            }
        }
    }
}

@Serializable
data class LocalLoaderModelState(
    val isVisible: Boolean = false
)
